import React from"react";export const HeaderTitleContext=React.createContext([]);export const HeaderSetTitleContext=React.createContext(()=>{});